import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function CheckList({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 18 18' {...props}>
      <Path
        d='M15.3228 6.89764V2.68504C15.3228 1.75442 14.5684 1 13.6378 1H2.68504C1.75442 1 1 1.75442 1
          2.68504V14.4803C1 15.4109 1.75442 16.1654 2.68504 16.1654H6.89764'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.26938 11.1088H6.90127'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.26562 7.73376H10.2676'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.26562 4.47595H11.9526'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M3.6322 11.2141C3.69036 11.2141 3.73751 11.1669 3.73751 11.1088C3.73751 11.0506 3.69036 11.0034 3.6322
        11.0034C3.57403 11.0034 3.52688 11.0506 3.52688 11.1088C3.52688 11.1669 3.57403 11.2141 3.6322 11.2141'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M3.6322 7.83907C3.69036 7.83907 3.73751 7.79192 3.73751 7.73376C3.73751 7.6756 3.69036 7.62844 3.6322
        7.62844C3.57403 7.62844 3.52688 7.6756 3.52688 7.73376C3.52688 7.79192 3.57403 7.83907 3.6322 7.83907'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M3.6322 4.58126C3.69036 4.58126 3.73751 4.53411 3.73751 4.47595C3.73751 4.41778 3.69036 4.37063
        3.6322 4.37063C3.57403 4.37063 3.52688 4.41778 3.52688 4.47595C3.52688 4.53411 3.57403 4.58126 3.6322 4.58126'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M13.221 9.42188C15.3149 9.42188 17.0124 11.1193 17.0124 13.2132C17.0124 15.3071 15.3149 17.0046
        13.221 17.0046C11.1271 17.0046 9.42969 15.3071 9.42969 13.2132C9.42969 11.1193 11.1271 9.42188 13.221 9.42188'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M14.536 12.5625L12.8981 14.2004L11.9141 13.2171'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

CheckList.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default CheckList
